module.exports = __webpack_public_path__ + "media/images/flags/AL-729e9acec7c94c45c89f6ee62251a2ea.svg";